<!--
 * @Description: 
 * @Author: YH
 * @Date: 2023-02-24 18:00:06
 * @LastEditTime: 2023-03-03 14:16:46
 * @LastEditors: YH
 * @Reference: 
-->
<template>
  <el-submenu :index="(menu.name || uniqueId).toLowerCase()">
    <template slot="title">
      <i v-if="menu.icon" :class="`fa ${menu.icon}`"></i>
      <i v-if="menu.icon === undefined & !menu.iconSvg" class="fa fa-folder-o"></i>
      <d2-icon-svg v-if="menu.iconSvg" :name="menu.iconSvg"/>
      <span slot="title" class="title">{{ $t(`menus.${menu.name}`) }}</span>
    </template>
    <template v-for="(child, childIndex) in menu.children">
      <d2-layout-header-aside-menu-item v-if="child.children === undefined" :menu="child" :key="childIndex"/>
      <d2-layout-header-aside-menu-sub v-else :menu="child" :key="childIndex"/>
    </template>
  </el-submenu>
</template>

<script>
import { uniqueId } from 'lodash'
// 组件
import d2LayoutMainMenuItem from '../menu-item'

export default {
  name: 'd2-layout-header-aside-menu-sub',
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem
  },
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      uniqueId: uniqueId('d2-menu-empty-')
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/components/menu-sub/index.vue"
}
</vue-filename-injector>
